<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.29412 7.55556C8.29412 7.24873 8.57903 7 8.93048 7H18.3636C18.7151 7 19 7.24873 19 7.55556V7.87302C19 8.17984 18.7151 8.42857 18.3636 8.42857H8.93048C8.57903 8.42857 8.29412 8.17984 8.29412 7.87302V7.55556Z"
      fill="#929292"
    />
    <path
      d="M5 7.55556C5 7.24873 5.28491 7 5.63636 7H6.01069C6.36215 7 6.64706 7.24873 6.64706 7.55556V7.87302C6.64706 8.17984 6.36215 8.42857 6.0107 8.42857H5.63636C5.28491 8.42857 5 8.17984 5 7.87302V7.55556Z"
      fill="#929292"
    />
    <path
      d="M8.29412 11.8413C8.29412 11.5344 8.57903 11.2857 8.93048 11.2857H18.3636C18.7151 11.2857 19 11.5344 19 11.8413V12.1587C19 12.4656 18.7151 12.7143 18.3636 12.7143H8.93048C8.57903 12.7143 8.29412 12.4656 8.29412 12.1587V11.8413Z"
      fill="#929292"
    />
    <path
      d="M5 11.8413C5 11.5344 5.28491 11.2857 5.63636 11.2857H6.01069C6.36215 11.2857 6.64706 11.5344 6.64706 11.8413V12.1587C6.64706 12.4656 6.36215 12.7143 6.0107 12.7143H5.63636C5.28491 12.7143 5 12.4656 5 12.1587V11.8413Z"
      fill="#929292"
    />
    <path
      d="M8.29412 16.127C8.29412 15.8202 8.57903 15.5714 8.93048 15.5714H18.3636C18.7151 15.5714 19 15.8202 19 16.127V16.4444C19 16.7513 18.7151 17 18.3636 17H8.93048C8.57903 17 8.29412 16.7513 8.29412 16.4444V16.127Z"
      fill="#929292"
    />
    <path
      d="M5 16.127C5 15.8202 5.28491 15.5714 5.63636 15.5714H6.01069C6.36215 15.5714 6.64706 15.8202 6.64706 16.127V16.4444C6.64706 16.7513 6.36215 17 6.0107 17H5.63636C5.28491 17 5 16.7513 5 16.4444V16.127Z"
      fill="#929292"
    />
  </svg>
</template>

<script>
export default {
  name: 'list-icon',
}
</script>



// WEBPACK FOOTER //
// src/templates/pages/lk/leads/icons/list-icon.vue